export const last = <T>(array: T[]): T | undefined =>
  (array?.length && array[array.length - 1]) || undefined
